import { NavLink } from "react-router-dom";
import { useState } from "react";
import { IoChevronDown } from "react-icons/io5";

const MegaMenu = ({ title, items }) => {
  const [activeItem, setActiveItem] = useState(items[0]);
  const [isOpen, setIsOpen] = useState(false);

  let closeTimeout;

  const handleMouseEnter = () => {
    clearTimeout(closeTimeout);
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    closeTimeout = setTimeout(() => {
      setIsOpen(false);
    }, 120);
  };

  return (
    <div
      className="nav-dropdown mega-dropdown"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className="nav-link dropdown-title">
        {title}
        <IoChevronDown className="pillars-arrow" />
      </span>

      {/* Always mounted - controlled by class */}
      <div className={`mega-menu ${isOpen ? "open" : ""}`}>
        <div className="mega-left programs-menu">
          <p className="text-secondary programs-title">Programs</p>

          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className="program-item"
              onMouseEnter={() => setActiveItem(item)}
            >
              <span>{item.label}</span>
              <span className="program-arrow">→</span>
            </NavLink>
          ))}
        </div>

        <div className="mega-right">
          {activeItem.image && (
            <img
              src={activeItem.image}
              alt={activeItem.heading}
              className="mega-image"
            />
          )}

          <div className="mega-content">
            <h4>{activeItem.heading}</h4>
            <p>{activeItem.description}</p>

            <NavLink to={activeItem.to} className="mega-cta">
              {activeItem.buttonLabel} →
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
